// prettier-ignore
const map = {
    'amazon': require('!!raw-loader!./svg/amazon.svg'),
    'bandcamp': require('!!raw-loader!./svg/bandcamp.svg'),
    'px500': require('!!raw-loader!./svg/px500-circle.svg'),
    'academia': require('!!raw-loader!./svg/academia-circle.svg'),
    'angel-list': require('!!raw-loader!./svg/angel-list.svg'),
    'behance': require('!!raw-loader!./svg/behance-circle.svg'),
    'bereal': require('!!raw-loader!./svg/bereal.svg'),
    'blogger': require('!!raw-loader!./svg/blogger-circle.svg'),
    'bluesky': require('!!raw-loader!./svg/bluesky.svg'),
    'buy-me-a-coffee': require('!!raw-loader!./svg/buy-me-a-coffee.svg'),
    'cara': require('!!raw-loader!./svg/cara.svg'),
    'care': require('!!raw-loader!./svg/care-circle.svg'),
    'clippings': require('!!raw-loader!./svg/clippings.svg'),
    'codepen': require('!!raw-loader!./svg/codepen.svg'),
    'deviantart': require('!!raw-loader!./svg/deviantart.svg'),
    'discord': require('!!raw-loader!./svg/discord.svg'),
    'dlive': require('!!raw-loader!./svg/dlive.svg'),
    'dribbble': require('!!raw-loader!./svg/dribbble-circle.svg'),
    'duolingo': require('!!raw-loader!./svg/duolingo.svg'),
    'email': require('!!raw-loader!./svg/email.svg'),
    'etsy': require('!!raw-loader!./svg/etsy-circle.svg'),
    'facebook': require('!!raw-loader!./svg/facebook-circle.svg'),
    'fitbit': require('!!raw-loader!./svg/fitbit-circle.svg'),
    'fiverr': require('!!raw-loader!./svg/fiverr-circle.svg'),
    'flickr': require('!!raw-loader!./svg/flickr-circle.svg'),
    'flipboard': require('!!raw-loader!./svg/flipboard-circle.svg'),
    'foursquare': require('!!raw-loader!./svg/foursquare-circle.svg'),
    'github': require('!!raw-loader!./svg/github-circle.svg'),
    'gitlab': require('!!raw-loader!./svg/gitlab.svg'),
    'gofundme': require('!!raw-loader!./svg/gofundme-circle.svg'),
    'goodreads': require('!!raw-loader!./svg/goodreads-circle.svg'),
    'google-scholar': require('!!raw-loader!./svg/google-scholar-circle.svg'),
    'highbrow': require('!!raw-loader!./svg/highbrow-circle.svg'),
    'huggingface': require('!!raw-loader!./svg/huggingface.svg'),
    'itch': require('!!raw-loader!./svg/itch.svg'),
    'imdb': require('!!raw-loader!./svg/imdb.svg'),
    'indiegogo': require('!!raw-loader!./svg/indiegogo-circle.svg'),
    'instagram': require('!!raw-loader!./svg/instagram-circle.svg'),
    'kickstarter': require('!!raw-loader!./svg/kickstarter-circle.svg'),
    'lastfm': require('!!raw-loader!./svg/lastfm-circle.svg'),
    'letterboxd': require('!!raw-loader!./svg/letterboxd.svg'),
    'linkedin': require('!!raw-loader!./svg/linkedin-circle.svg'),
    'medium': require('!!raw-loader!./svg/medium-circle.svg'),
    'mixcloud': require('!!raw-loader!./svg/mixcloud.svg'),
    'mastodon': require('!!raw-loader!./svg/mastodon.svg'),
    'odysee': require('!!raw-loader!./svg/odysee.svg'),
    'orcid': require('!!raw-loader!./svg/orcid-circle.svg'),
    'patreon': require('!!raw-loader!./svg/patreon-circle.svg'),
    'picfair': require('!!raw-loader!./svg/picfair.svg'),
    'pixelfed': require('!!raw-loader!./svg/pixelfed.svg'),
    'pinterest': require('!!raw-loader!./svg/pinterest-circle.svg'),
    'pocket': require('!!raw-loader!./svg/pocket-circle.svg'),
    'post.news': require('!!raw-loader!./svg/post.news.svg'),
    'product-hunt': require('!!raw-loader!./svg/product-hunt.svg'),
    'quora': require('!!raw-loader!./svg/quora-circle.svg'),
    'reddit': require('!!raw-loader!./svg/reddit-circle.svg'),
    'researchgate': require('!!raw-loader!./svg/researchgate-circle.svg'),
    'researcherid': require('!!raw-loader!./svg/researcherid-circle.svg'),
    'scopus': require('!!raw-loader!./svg/scopus.svg'),
    'scribd': require('!!raw-loader!./svg/scribd.svg'),
    'sketchfab': require('!!raw-loader!./svg/sketchfab.svg'),
    'skillshare': require('!!raw-loader!./svg/skillshare-circle.svg'),
    'slideshare': require('!!raw-loader!./svg/slideshare-circle.svg'),
    'snapchat': require('!!raw-loader!./svg/snapchat.svg'),
    'soundcloud': require('!!raw-loader!./svg/soundcloud-circle.svg'),
    'spotify': require('!!raw-loader!./svg/spotify-circle.svg'),
    'substack': require('!!raw-loader!./svg/substack.svg'),
    'stackexchange': require('!!raw-loader!./svg/stackexchange-circle.svg'),
    'stackoverflow': require('!!raw-loader!./svg/stackoverflow-circle.svg'),
    'stage32': require('!!raw-loader!./svg/stage32.svg'),
    'strava': require('!!raw-loader!./svg/strava-circle.svg'),
    'telegram': require('!!raw-loader!./svg/telegram-circle.svg'),
    'threads': require('!!raw-loader!./svg/threads.svg'),
    'tiktok': require('!!raw-loader!./svg/tiktok-circle.svg'),
    'triller': require('!!raw-loader!./svg/triller.svg'),
    'tumblr': require('!!raw-loader!./svg/tumblr-circle.svg'),
    'twitch': require('!!raw-loader!./svg/twitch-circle.svg'),
    'twitter': require('!!raw-loader!./svg/twitter-circle.svg'),
    'unsplash': require('!!raw-loader!./svg/unsplash-circle.svg'),
    'upwork': require('!!raw-loader!./svg/upwork-circle.svg'),
    'vk': require('!!raw-loader!./svg/vk-circle.svg'),
    'vsco': require('!!raw-loader!./svg/vsco.svg'),
    'vimeo': require('!!raw-loader!./svg/vimeo-circle.svg'),
    'vine': require('!!raw-loader!./svg/vine-circle.svg'),
    'web-of-science': require('!!raw-loader!./svg/web-of-science.svg'),
    'weibo': require('!!raw-loader!./svg/weibo-circle.svg'),
    'whatsapp': require('!!raw-loader!./svg/whatsapp-circle.svg'),
    'wikipedia': require('!!raw-loader!./svg/wikipedia-circle.svg'),
    'wordpress': require('!!raw-loader!./svg/wordpress-circle.svg'),
    'xbox': require('!!raw-loader!./svg/xbox.svg'),
    'xing': require('!!raw-loader!./svg/xing-circle.svg'),
    'yelp': require('!!raw-loader!./svg/yelp-circle.svg'),
    'youtube': require('!!raw-loader!./svg/youtube-circle.svg'),
}

module.exports = map
